module.exports = __webpack_public_path__ + "img/esp-sertifikat-3.b6a166f8.jpg";